import React, { Component } from 'react'
import { connect } from 'react-redux'
import { LinkedInput, LinkedInputGroup } from 'components/basic'
import { Installation } from 'config'
import http from 'API/http'
import { notify } from 'helpers'
class LoginPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      newPassword: {
        a: '',
        b: ''
      },
      errorMsg: null,
      error: false,
      subpage: 'LOGIN',
      resetUser: '',
      resetString: '',
      loading: false
    }
    window.addEventListener('keydown', e => e.keyCode === 13 && this.state.subpage === 'LOGIN' && !window.localStorage.getItem('flow_basic_auth') && this.handleSubmit())
  }
  async componentDidMount () {
    this.checkBackend()
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: 'Login'
    })
    this.props.dispatch({
      type: 'SET_LANGUAGE',
      payload: 'EN'
    })
    if (window.location.hash.indexOf('set') !== -1) {
      setTimeout(async e => {
        let err, res
        var hash = window.location.hash.split('/')
        var key = hash[hash.length - 1]
        this.setState({resetString: key});
        [err, res] = await http.get('2.3/password/reset/user/' + key)
        if (err) {
          window.location.hash('/login')
          return this.setSubpage('LOGIN')
        }
        this.setState({resetUser: res.data})
        this.setSubpage('SET')
      }, 0)
    }
    this.setSubpage()

    var user = window.localStorage.getItem('flow_basic_auth')
    if (!user) return
    user = JSON.parse(user)
    this.setState({
      username: user.username,
      password: user.password
    }, () => {
      setTimeout(() => {
        this.handleSubmit()
      }, 0)
    })
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.siteReducer.access === nextProps.siteReducer.access) return
    this.checkBackend()
  }
  async checkBackend () {
    var err, res
    [err, res] = await http.get('2.3/password/flow')
    if (!err) {
      return this.props.dispatch({
        type: 'SET_ACCESS',
        payload: 'FLOW'
      })
    }
    this.props.dispatch({
      type: 'SET_ACCESS',
      payload: 'NETADMIN'
    })
  }
  async handleSubmit () {
    // eslint-disable-next-line
    var err, res
    [err, res] = await http.get('2.3/password/login', {}, {
      username: this.state.username,
      password: this.state.password
    })
    console.log(res);
    if (err) {
      if(res.cause) notify.alert('', res.cause, 'error')
      return this.setState({error: true})
    }
    this.props.dispatch({
      type: 'SET_BASIC_AUTH',
      payload: {
        username: this.state.username,
        password: this.state.password
      }
    })
    this.props.dispatch({
      type: 'SET_LOGIN',
      payload: {
        user: res.data,
        token: ''
      }
    })
    window.localStorage.setItem('flow_basic_auth', JSON.stringify({
      username: this.state.username,
      password: this.state.password
    }))
    if (window.location.hash.indexOf('login') !== -1) {
      window.location.hash = '/flow/dashboard'
    }
  }
  async resetPassword () {
    this.setState({loading: true})
    var err, res
    [err, res] = await http.post('2.3/password/reset', {
      emailAddress: this.state.emailAddress
    })
    if (err) return notify.alert('', res.cause, 'error')
    notify.alert('A password recovery email will be sent if the account exists.', '', 'success')
    this.setState({loading: false})
  }
  async setPassword () {
    var err, res
    if (this.state.newPassword.a.length < 10) {
      return this.setState({error: true, errorMsg: 'Your password has to be atleast 10 characters in length'})
    }
    if (this.state.newPassword.a !== this.state.newPassword.b) {
      return this.setState({error: true, errorMsg: 'Your passwords do not match'})
    }
    var valid = await new Promise((resolve, reject) => {
      this.form.check(resolve)
    })
    if (!valid) return this.setState({error: true, errorMsg: 'Your password does not meet the requirements'});

    [err, res] = await http.post('2.3/password/reset/' + this.state.resetString, {
      password: this.state.newPassword.a
    })
    if (err) return notify.alert('', res.cause, 'error')
    notify.alert('Your password has been updated', '', 'success')
    window.location.hash = '/login'
    this.setSubpage('LOGIN')
    this.setState({ username: this.state.resetUser })
  }
  setSubpage (page) {
    if (page) return this.setState({subpage: page, error: false})
    if (window.location.hash.indexOf('set') !== -1) return this.setState({subpage: 'SET', error: false})
    if (window.location.hash.indexOf('request') !== -1) return this.setState({subpage: 'REQUEST', error: false})
    this.setState({subpage: 'LOGIN'})
  }
  render () {
    console.log(this.props)
    return (
      <div className='site-wrapper sidebar-active'>
        <nav className='navbar navbar-fixed-top navbar-default'>
          <div className='container-fluid'>
            <div className='navbar-header'>
              <a className='navbar-brand' href='/#/'><img src='/static/flowlogo.svg' width='40' height='40' /> <span>Flow</span></a>
            </div>
            <ul className='nav navbar-nav navbar-right'>
              <li>
                <a className='header-button'>{Installation.systemName}</a>
              </li>
            </ul>
          </div>
        </nav>
        <div className='login-page'>
          {this.state.subpage === 'LOGIN' &&
            <div className='login-box'>
              <img src='/static/flowlogo.svg' className='flow-login-logo' width='120' />
              <div className={'alert alert-danger ' + (!this.state.error ? 'hidden' : '')}>
                Wrong username or password, please try again.
              </div>
              <div className='form-group'>
                <label>{this.props.siteReducer.access === 'FLOW' ? 'Email' : 'Username'}</label>
                <LinkedInput context={this} path='username' />
              </div>
              <div className='form-group'>
                <label>Password</label>
                <LinkedInput type='password' context={this} path='password' />
              </div>
              <div className='row'>
                <div className='col-xs-6'>
                  {Installation.enable.passwordRecovery && <a href='/#/password/request' onClick={e => {
                    this.setSubpage('REQUEST')
                  }}>Request new password</a>}
                </div>
                <div className='col-xs-6'>
                  <a className='btn btn-primary pull-right' onClick={e => this.handleSubmit()}>ENTER</a>
                </div>
              </div>
              <span className='maintrac-login-logo'>{Installation.systemName}</span>
            </div>
          }
          {this.state.subpage === 'SET' &&
            <div className='login-box'>
              <LinkedInputGroup ref={(form) => { this.form = form }}>
                <img src='/static/flowlogo.svg' className='flow-login-logo' width='120' />
                <div className={'alert alert-danger ' + (!this.state.error ? 'hidden' : '')}>
                  {this.state.errorMsg}
                </div>
                <h4>Set password for <b>{this.state.resetUser}</b></h4>
                <div className='form-group'>
                  <label>Password <small>Minimum of 10 characters in length (A-ö, 0-9, !"#€%&/\()=?`")</small></label>
                  <LinkedInput validate={/^[^:]{10,}$/} type='password' context={this} path='newPassword.a' />
                </div>
                <div className='form-group'>
                  <label>
                    Repeat Password
                  </label>
                  <LinkedInput type='password' validate={/^[^:]{10,}$/} context={this} path='newPassword.b' />
                </div>
                <div className='row'>
                  <div className='col-xs-6' />
                  <div className='col-xs-6'>
                    <a className='btn btn-primary pull-right' onClick={e => this.setPassword()}>CREATE PASSWORD</a>
                  </div>
                </div>
                <span className='maintrac-login-logo'>{Installation.systemName}</span>
              </LinkedInputGroup>
            </div>
          }
          {this.state.subpage === 'REQUEST' &&
          <div className='login-box'>
            <img src='/static/flowlogo.svg' className='flow-login-logo' width='120' />
            <div className={'alert alert-danger ' + (!this.state.error ? 'hidden' : '')}>
              Wrong email or password, please try again.
            </div>
            <div className='form-group'>
              <label>
                Email address
              </label>
              <LinkedInput context={this} path='emailAddress' />
            </div>
            <div className='row'>
              <div className='col-xs-6'>
                <a href='/#/' onClick={e => {
                  this.setSubpage('LOGIN')
                }}>Back to login</a>
              </div>
              <div className='col-xs-6'>
                <a className='btn btn-primary pull-right' onClick={e => this.resetPassword()}>{!this.state.loading ? 'REQUEST NEW PASSWORD' : <i className='fa fa-spin fa-spinner' />}</a>
              </div>
            </div>
            <span className='maintrac-login-logo'>{Installation.systemName}</span>
          </div>
        }
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
LoginPage = connect(state => state)(LoginPage)
export default LoginPage



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/core/login.js